import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { style: {"flex":"1","max-height":"200px","overflow":"auto"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "Upload", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 업로드 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_UploadOutlined = _resolveComponent("UploadOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_upload, _mergeProps({ "file-list": _ctx.fileList }, _ctx.getComponentProps, {
      "max-count": _ctx.max,
      multiple: _ctx.max > 1,
      capture: undefined,
      "custom-request": _ctx.beforeUpload2,
      onPreview: _ctx.handlePreview,
      onChange: _ctx.onChange
    }), {
      default: _withCtx(() => [
        (_ctx.fileList && _ctx.fileList.length < _ctx.max)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.mediaType === 'image')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_plus_outlined),
                    _hoisted_3
                  ]))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    disabled: _ctx.disabled
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UploadOutlined),
                      _hoisted_4
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16, ["file-list", "max-count", "multiple", "custom-request", "onPreview", "onChange"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.previewVisible,
      footer: null,
      "destroy-on-close": "",
      onCancel: _ctx.handleCancel
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponentProps.componentName), {
          alt: "example",
          controls: "",
          style: {"width":"100%","max-width":"50vw max-height: 50vh"},
          src: _ctx.previewMedia
        }, null, 8, ["src"]))
      ]),
      _: 1
    }, 8, ["visible", "onCancel"])
  ]))
}